/*
 * @Author: Jing
 * @Date: 2021-12-24 18:02:39
 * @Descripttion:
 */
import type { Directive, App } from 'vue'
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcodejs2-fix'

const barCode: Directive = {
    beforeMount(el, binding) {
        if (!(el instanceof SVGElement)) {
            return
        }
        let code = binding.value
        JsBarcode(el, code, {
            format: 'CODE128',
            textAlign: 'left',
            width: 1.5,
            height: 45,
            fontSize: 12,
        })
    },
}
const bigBar: Directive = {
    beforeMount(el, binding) {
        // console.log('binding', el, binding)
        if (!(el instanceof SVGElement)) {
            return
        }
        let code = binding.value
        console.log('code', code)
        JsBarcode(el, code, {
            format: 'CODE128',
            textAlign: 'left',
            width: 4,
            height: 130,
            fontSize: 20,
        })
    },
}

export function setupBarCodeDirective(app: App) {
    app.directive('barcode', barCode)
    app.directive('bigbar', bigBar)
}

export { bigBar, barCode }
